module.exports = __webpack_public_path__ + "media/images/Delete-4f3cdf26df7dc85c5176903372bec74f.svg";